import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import OutlinedInput from "@material-ui/core/OutlinedInput";
import {InputLabel,InputAdornment} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import {MenuItem, Select} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  displayFlex: {
    display: 'flex',
    alignItems: 'center',
    // padding: 10,
  }
}));

export default function Index(props) {
  const classes = useStyles();

  const {
    item = {},

    onChange,id,
    label, value,
    unitLabel, unitValue, unitList,
    startEdge
  } = props;
  console.log(startEdge)
  const {
    // id,
    type =   'text',
    // label,
    placeholder,
    labelWidth = 53,
    dropdownList = [],
    errorText,
    // value,
    error,
    required = false,
    min, max,
    disable = false,
    multiline = false,
    defaultValue = '',
  } = item;

  return (
    <div className={classes.displayFlex}>

      <FormControl variant="outlined">
        <InputLabel
          // htmlFor={props.id || props.label}
                    error={props.error}>{props.label}</InputLabel>
        <OutlinedInput
          disabled={disable}
          id={id || label}
          type={type}
          value={value}
          placeholder={placeholder}
          // margin="normal"
          // multiline={true}
          // required={required}
          fullWidth
          defaultValue={defaultValue}
          error={error}
          onChange={(event) =>
            onChange(event.target.value, id || label)
          }
          labelWidth={labelWidth}
          style={{border: 'none'}}
          startAdornment={

              startEdge? <InputAdornment position='start'>
                {startEdge}
              </InputAdornment> : ''

          }

          endAdornment={
            unitList ? <InputAdornment>
              <Select
                // required={required}
                id={unitLabel}
                value={unitValue}
                onChange={(event) => {
                  onChange(event.target.value, unitLabel)
                }}
                label={label}
                // labelWidth={labelWidth}
                // disabled={disable}
                defaultValue={defaultValue}
              >
                <MenuItem value="">
                  <em>Please Select</em>
                </MenuItem>
                {unitList.map((val, index) => (
                  <MenuItem value={val.value} key={`${val.value + index}`} className='display-flex align-items-center'>
                    {val?.icon && <img src={val.icon} alt={''} width={30} className='mr-10'/>}
                    {val.text}
                  </MenuItem>))}
              </Select>
            </InputAdornment> : <></>}
        />
      </FormControl>
    </div>
  );
}
